import { render, staticRenderFns } from "./DatabaseListeners.vue?vue&type=template&id=0bf68fac&"
import script from "./DatabaseListeners.vue?vue&type=script&lang=js&"
export * from "./DatabaseListeners.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports